export default __webpack_public_path__ + "static/media/pixel_sorting.25e4fbdd.jpg";